/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Guide(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Guide',
      'aria-hidden': true,
      focusable: false,
      width:  14 * scale,
      height: 13 * scale,
      viewBox: '0 0 14 13',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M.658.026 6 1.834V13L.757 11.67A1.01 1.01 0 0 1 0 10.685V.508A.504.504 0 0 1 .658.026M8 1.834 13.342.026A.498.498 0 0 1 14 .508v10.177c0 .466-.312.872-.757.985L8 13z","fill":"currentColor","fillRule":"evenodd"}))
}
